"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { ItemTitle } from "@opensea/next-ui-kit";
import { LiveAnimation, TableCell, TableRow, Truncate, tableRowSizeVariants } from "@opensea/ui-kit";
import { ActivityFeedLiveTimestamp } from "@/components/activity-feed/ActivityFeedLiveTimestamp";
import { ActivityFrom } from "@/components/activity-feed/ActivityFrom";
import { ActivityPrice } from "@/components/activity-feed/ActivityPrice";
import { SALES_FEED_TABLE_COLUMN_CLASSNAMES } from "@/components/collection/drops/constants";
import { ItemAvatar } from "@/components/items/avatar/ItemAvatar";
import { ItemLink } from "@/components/items/ItemLink";
import { ItemPreviewTooltip } from "@/components/items/ItemPreviewTooltip/";
import { SalesFeedTableRowFragment } from "./SalesFeedTableRow.fragment";
import { SalesFeedTableRowSkeleton } from "./SalesFeedTableRowSkeleton";
export function SalesFeedTableRow(t0) {
  const $ = _c(61);
  const {
    context,
    item: itemKey
  } = t0;
  let T0;
  let T1;
  let T2;
  let T3;
  let T4;
  let activity;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== context?.itemsLiveAddedAt || $[1] !== context?.override || $[2] !== itemKey) {
    t12 = Symbol.for("react.early_return_sentinel");
    bb0: {
      activity = readFragment(SalesFeedTableRowFragment, itemKey);
      const {
        text,
        image
      } = tableRowSizeVariants({
        size: "md"
      });
      if (activity?.__typename !== "Sale" || !activity.item) {
        const t13 = context?.override;
        let t14;
        if ($[21] !== t13) {
          t14 = <SalesFeedTableRowSkeleton override={t13} />;
          $[21] = t13;
          $[22] = t14;
        } else {
          t14 = $[22];
        }
        t12 = t14;
        break bb0;
      }
      T4 = LiveAnimation;
      t9 = activity.id;
      t10 = context?.itemsLiveAddedAt?.get(activity.id);
      t11 = "table";
      T3 = ItemLink;
      t8 = activity.item;
      T2 = TableRow;
      t4 = "w-full";
      t5 = true;
      const t13 = <ItemAvatar className={image()} item={activity.item} size={32} />;
      const t14 = <ItemTitle className={text()}>{activity.item.name}</ItemTitle>;
      let t15;
      if ($[23] !== t14) {
        t15 = <Truncate>{t14}</Truncate>;
        $[23] = t14;
        $[24] = t15;
      } else {
        t15 = $[24];
      }
      let t16;
      if ($[25] !== activity || $[26] !== t15) {
        t16 = <ItemPreviewTooltip item={activity.item}>{t15}</ItemPreviewTooltip>;
        $[25] = activity;
        $[26] = t15;
        $[27] = t16;
      } else {
        t16 = $[27];
      }
      if ($[28] !== t13 || $[29] !== t16) {
        t6 = <TableCell className={SALES_FEED_TABLE_COLUMN_CLASSNAMES.image}>{t13}{t16}</TableCell>;
        $[28] = t13;
        $[29] = t16;
        $[30] = t6;
      } else {
        t6 = $[30];
      }
      const t17 = <ActivityPrice activity={activity} className={text()} />;
      if ($[31] !== t17) {
        t7 = <TableCell className={SALES_FEED_TABLE_COLUMN_CLASSNAMES.price}>{t17}</TableCell>;
        $[31] = t17;
        $[32] = t7;
      } else {
        t7 = $[32];
      }
      T1 = TableCell;
      t3 = SALES_FEED_TABLE_COLUMN_CLASSNAMES.seller;
      T0 = ActivityFrom;
      t1 = activity;
      t2 = text();
    }
    $[0] = context?.itemsLiveAddedAt;
    $[1] = context?.override;
    $[2] = itemKey;
    $[3] = T0;
    $[4] = T1;
    $[5] = T2;
    $[6] = T3;
    $[7] = T4;
    $[8] = activity;
    $[9] = t1;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[3];
    T1 = $[4];
    T2 = $[5];
    T3 = $[6];
    T4 = $[7];
    activity = $[8];
    t1 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  if (t12 !== Symbol.for("react.early_return_sentinel")) {
    return t12;
  }
  let t13;
  if ($[33] !== T0 || $[34] !== t1 || $[35] !== t2) {
    t13 = <T0 activity={t1} className={t2} />;
    $[33] = T0;
    $[34] = t1;
    $[35] = t2;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== T1 || $[38] !== t13 || $[39] !== t3) {
    t14 = <T1 className={t3}>{t13}</T1>;
    $[37] = T1;
    $[38] = t13;
    $[39] = t3;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== activity) {
    t15 = <TableCell className={SALES_FEED_TABLE_COLUMN_CLASSNAMES.timestamp}><ActivityFeedLiveTimestamp activity={activity} showArrow={true} /></TableCell>;
    $[41] = activity;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== T2 || $[44] !== t14 || $[45] !== t15 || $[46] !== t4 || $[47] !== t5 || $[48] !== t6 || $[49] !== t7) {
    t16 = <T2 className={t4} interactive={t5}>{t6}{t7}{t14}{t15}</T2>;
    $[43] = T2;
    $[44] = t14;
    $[45] = t15;
    $[46] = t4;
    $[47] = t5;
    $[48] = t6;
    $[49] = t7;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== T3 || $[52] !== t16 || $[53] !== t8) {
    t17 = <T3 item={t8}>{t16}</T3>;
    $[51] = T3;
    $[52] = t16;
    $[53] = t8;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  let t18;
  if ($[55] !== T4 || $[56] !== t10 || $[57] !== t11 || $[58] !== t17 || $[59] !== t9) {
    t18 = <T4 itemKey={t9} liveAddedAt={t10} variant={t11}>{t17}</T4>;
    $[55] = T4;
    $[56] = t10;
    $[57] = t11;
    $[58] = t17;
    $[59] = t9;
    $[60] = t18;
  } else {
    t18 = $[60];
  }
  return t18;
}